<template>
    <v-card outlined class="pa-2 mb-2 pb-0">
        <table>
            <tr>
                <td>
                    <v-container>
                        <v-row>
                            <v-col cols="4">
                                <v-text-field
                                    dense 
                                    v-model="p1"
                                    clearable 
                                    label="1" 
                                    item-text="number" 
                                    outlined
                                    suffix="%"
                                    />
                            </v-col>
                            <v-col cols="4">
                                <v-text-field
                                    dense 
                                    v-model="p2"
                                    clearable 
                                    label="2" 
                                    item-text="number" 
                                    outlined
                                    suffix="%"
                                    />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-text-field
                                    dense 
                                    v-model="p3"
                                    clearable 
                                    label="3" 
                                    item-text="number" 
                                    outlined
                                    suffix="%"
                                    />
                            </v-col>
                            <v-col cols="4">
                                <v-text-field
                                    dense 
                                    v-model="p4"
                                    clearable 
                                    label="4" 
                                    item-text="number" 
                                    outlined
                                    suffix="%"
                                    />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-text-field
                                    dense 
                                    v-model="p5"
                                    clearable 
                                    label="5" 
                                    item-text="number" 
                                    outlined
                                    suffix="%"
                                    />
                            </v-col>
                            <v-col cols="4">
                                <v-text-field
                                    dense 
                                    v-model="p6"
                                    clearable 
                                    label="6" 
                                    item-text="number" 
                                    outlined
                                    suffix="%"
                                    />
                            </v-col>
                        </v-row>
                    </v-container>
                </td>
            </tr>
        </table>
    </v-card>
</template>

<script>
    export default {
        props: {
            value: Array,
        },
        computed: {
            p1: {
                get: function() {
                    if (this.$props.value == null || this.$props.value == '') {
                        return 0
                    }
                    return this.$props.value[0]
                },
                set: function(v) {
                    this.$emit("input", [
                        v * 1,
                        this.p2,
                        this.p3,
                        this.p4,
                        this.p5,
                        this.p6,
                    ])
                }
            },
            p2: {
                get: function() {
                    if (this.$props.value == null || this.$props.value == '') {
                        return 0
                    }
                    return this.$props.value[1]
                },
                set: function(v) {
                    this.$emit("input", [
                        this.p1,
                        v * 1,
                        this.p3,
                        this.p4,
                        this.p5,
                        this.p6,
                    ])
                }
            },
            p3: {
                get: function() {
                    if (this.$props.value == null || this.$props.value == '') {
                        return 0
                    }
                    return this.$props.value[2]
                },
                set: function(v) {
                    this.$emit("input", [
                        this.p1,
                        this.p2,
                        v * 1,
                        this.p4,
                        this.p5,
                        this.p6,
                    ])
                }
            },
            p4: {
                get: function() {
                    if (this.$props.value == null || this.$props.value == '') {
                        return 0
                    }
                    return this.$props.value[3]
                },
                set: function(v) {
                    this.$emit("input", [
                        this.p1,
                        this.p2,
                        this.p3,
                        v * 1,
                        this.p5,
                        this.p6,
                    ])
                }
            },
            p5: {
                get: function() {
                    if (this.$props.value == null || this.$props.value == '') {
                        return 0
                    }
                    return this.$props.value[4]
                },
                set: function(v) {
                    this.$emit("input", [
                        this.p1,
                        this.p2,
                        this.p3,
                        this.p4,
                        v * 1,
                        this.p6,
                    ])
                }
            },
            p6: {
                get: function() {
                    if (this.$props.value == null || this.$props.value == '') {
                        return 0
                    }
                    return this.$props.value[5]
                },
                set: function(v) {
                    this.$emit("input", [
                        this.p1,
                        this.p2,
                        this.p3,
                        this.p4,
                        this.p5,
                        v * 1,
                    ])
                }
            },
        },
        // data: function () {
        //     return {
        //         editItems: {
        //             top: 0,
        //             center: 0,
        //             bottom: 0
        //         }
        //     }
        // }
        created: function () {
            console.log("H created")
            if (this.$props.value == null || this.$props.value == '') {
                this.$emit("input", [0,0,0,0,0,0])
            }
        }
    }
</script>
